import WithRender from "../../templates/ui/loading.html";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getPersonalizeLoading"]),
    getLoadingClass: function () {
      return this.initialLoading ? "matrix_loadingInitial" : "";
    },
    getPersonalizeLoadingClass: function () {
      return this.getPersonalizeLoading ? "matrix_loadingPersonalize" : "";
    }
  },
  data() {
    return {
      isLoading: true,
      fullPage: false,
      height: 100,
      width: 100
    };
  },
  components: {
    Loading
  },
  props: ["initialLoading"]
});
